/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = String
 *
 * 2 = Int
 *
 * 3 = Float
 *
 * 4 = ImageAndVideo
 */
export enum GroupInputType {
  String = 1,
  Int = 2,
  Float = 3,
  ImageAndVideo = 4,
}
